"use client";

import { format, formatDistanceToNow } from "date-fns";
import { History } from "lucide-react";
import { cn } from "@/lib/utils";

interface EntityInstanceHistoryBadgeProps {
  /** Entity's own updated_at — used as the timestamp displayed */
  updatedAt?: string | null;
  className?: string;
  onClick?: () => void;
}

export const EntityInstanceHistoryBadge: React.FC<EntityInstanceHistoryBadgeProps> = ({
  updatedAt,
  className,
  onClick,
}) => {
  if (!updatedAt) return null;

  let parsed: Date | null = null;
  try {
    parsed = new Date(updatedAt);
    if (isNaN(parsed.getTime())) parsed = null;
  } catch {
    parsed = null;
  }
  if (!parsed) return null;

  const relative = formatDistanceToNow(parsed, { addSuffix: true });
  const exact = format(parsed, "yyyy-MM-dd HH:mm:ss");

  return (
    <button
      type="button"
      onClick={onClick}
      title={exact}
      className={cn(
        "inline-flex items-center gap-1 rounded text-xs font-normal text-gray-400 hover:text-gray-600",
        className,
      )}
    >
      <History className="h-3 w-3" />
      {relative}
    </button>
  );
};
